import { Routes } from '@angular/router';

export const RedirectedRoutes: Routes = [
    {
        path : 'SystemAdministration/User/Settings',
        redirectTo: 'Administration/User/Settings',
        pathMatch: 'full'
    },
    {
        path : 'SystemAdministration/User/Details/:userid',
        redirectTo: 'Administration/User/:userid/Details',
        pathMatch: 'full'
    },
    {
        path : 'SystemAdministration/User/Settings/:username',
        redirectTo: 'Administration/User/Settings/:username',
        pathMatch: 'full'
    },
    {
        path: 'Site/ApplicationSet/Details/:applicationid',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/Details',
        pathMatch: 'full'
    },
    {
        path: 'Site/ApplicationSet/CopyApplicationSet/:applicationid',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/CopyApplicationSet',
        pathMatch: 'full'
    },
    {
        path: 'Site/ApplicationSet/Settings',
        redirectTo : 'ApplicationSet/Plant/CreateNewApplicationSet',
        pathMatch: 'full'
    },
    {
        path : 'Site/ApplicationSet/Settings/:applicationid',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/Details',
        pathMatch: 'full'
    },
    {
        path: 'Site/CloudFile/Settings/:applicationid',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/SiteFiles/CloudFile',
        pathMatch: 'full'
    },
    {
        path: 'Site/CloudFile/Details/:applicationid',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/SiteFiles/CloudFile/Details',
        pathMatch: 'full'
    },
    {
        path: 'Site/ApplicationSet/:applicationid/SiteFiles/CloudFile/Details',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/SiteFiles/CloudFile/Details',
        pathMatch: 'full'
    },
    {
        path : 'Site/ApplicationFile/Settings/:applicationid',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/SiteFiles/ApplicationFile',
        pathMatch: 'full'
    },
    {
        path : 'Site/ApplicationFile/Details/:applicationid',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/SiteFiles/ApplicationFile/Details',
        pathMatch: 'full'
    },
    {
        path : 'Site/ApplicationSet/:applicationid/SiteFiles/ApplicationFile/Details',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/SiteFiles/ApplicationFile/Details',
        pathMatch: 'full'
    },
    {
        path : 'Site/UcfFile/Settings/:applicationid',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/SiteFiles/UcfFile',
        pathMatch: 'full'
    },
    {
        path : 'Site/UcfFile/Details/:applicationid',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/SiteFiles/UcfFile/Details',
        pathMatch: 'full'
    },
    {
        path : 'Site/ApplicationSet/:applicationid/SiteFiles/UcfFile/Details',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/SiteFiles/UcfFile/Details',
        pathMatch: 'full'
    },
    {
        path : 'Site/ApplicationSet/MiscFiles/:applicationid',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/MiscFiles',
        pathMatch: 'full'
    },
    {
        path : 'Site/ApplicationSet/SiteFiles/:applicationid',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/SiteFiles',
        pathMatch: 'full'
    },
    {
        path : 'Site/MiscFile/Details/:applicationid',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/MiscFiles/Details',
        pathMatch: 'full'
    },
    {
        path : 'Site/ApplicationSet/:applicationid/SiteFiles/MiscFiles/Details',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/SiteFiles/MiscFiles/Details',
        pathMatch: 'full'
    },
    {
        path : 'Site/MiscFile/Settings/:applicationid',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/MiscFiles/Settings',
        pathMatch: 'full'
    },
    {
        path: 'Site/ApplicationSet/CreateNewApplicationSetVersion/:applicationid',
        redirectTo : 'ApplicationSet/Plant/:applicationid/:applicationid/CreateNewApplicationSetVersion',
        pathMatch: 'full'
    },
    {
        path : 'Site/SiteAdministration/ActivatingSite',
        redirectTo : 'Administration/Plants/ActivatingSite',
        pathMatch: 'full'
    },
    {
        path : 'Site/SiteAdministration/Details/:plantid',
        redirectTo : 'Administration/Plants/:plantid',
        pathMatch: 'full'
    },
    {
        path : 'Site/SiteAdministration/Users/:plantid',
        redirectTo : 'Administration/Plants/:plantid/Users',
        pathMatch: 'full'
    },
    {
        path : 'Site/SiteAdministration/SiteUser/:plantid',
        redirectTo : 'Administration/Plants/:plantid/Users',
        pathMatch: 'full'
    },
    {
        path : 'Site/SiteAdministration/SiteAlarms/:plantid',
        redirectTo : 'Administration/Plants/:plantid/Alarms',
        pathMatch: 'full'
    },
    {
        path : 'Site/SiteAdministration/Alarms/:plantid',
        redirectTo : 'Administration/Plants/:plantid/Alarms',
        pathMatch: 'full'
    },
    {
        path : 'Site/SiteAdministration/Settings/:plantid',
        redirectTo : 'Administration/Plants/:plantid/Settings',
        pathMatch: 'full'
    },
    {
        path : 'Site/SiteAdministration/ConfirmDelete/:plantid',
        redirectTo : 'Administration/Plants/:plantid/ConfirmDelete',
        pathMatch: 'full'
    },
    {
        path : 'Site/SiteAdministration/Settings/:plantid',
        redirectTo : 'Administration/Plants/:plantid/Settings',
        pathMatch: 'full'
    },
    {
        path : 'Site/SiteAdministration',
        redirectTo : 'Administration/Plants',
        pathMatch: 'full'
    },
    {
        path : 'Site/SiteAdministration/ReplacingSite/:plantid',
        redirectTo : 'Administration/Plants/:plantid/Settings/ReplacingSite',
        pathMatch: 'full'
    },
    {
        path : 'Site/SiteAdministration/AssignUnassignSite/:plantid',
        redirectTo : 'Administration/Plants/:plantid/Settings/AssignUnassignSite',
        pathMatch: 'full'
    },
    {
        path : 'Site/Site/WebAccess/:plantid',
        redirectTo : '/Operating/Plants/:plantid/WebAccess',
        pathMatch: 'full'
    },
    {
        path : 'SystemAdministration/User',
        redirectTo : '/Administration/User',
        pathMatch : 'full'
    },
    {
        path : 'SystemAdministration/User/List',
        redirectTo : '/Administration/User',
        pathMatch : 'full'
    },
    {
        path : 'SystemAdministration/Tenant/Settings/:tenantid',
        redirectTo : '/Administration/TenantsOld/:tenantid/Settings',
        pathMatch : 'full'
    },
    {
        path : 'SystemAdministration/Tenant/Details/:tenantid',
        redirectTo : '/Administration/TenantsOld/:tenantid/Settings',
        pathMatch : 'full'
    },
    {
        path : 'SystemAdministration/Tenant/Settings',
        redirectTo : '/Administration/TenantsOld/Add',
        pathMatch : 'full'
    },
    {
        path : 'SystemAdministration/Tenant/CreateTenantFromTemplate',
        redirectTo : '/Administration/TenantsOld/CreateFromTemplate',
        pathMatch : 'full'
    },
    {
        path : 'SystemAdministration/Tenant',
        redirectTo : '/Administration/TenantsOld',
        pathMatch : 'full'
    },
    {
        path : 'SystemAdministration/UserRole/Settings/:plantroleid',
        redirectTo : '/Administration/PlantRoles/:plantroleid/Settings',
        pathMatch : 'full'
    },
    {
        path : 'SystemAdministration/UserRole/Details/:plantroleid',
        redirectTo : 'Administration/UserRoles/:plantroleid/Details',
        pathMatch : 'full'
    },
    {
        path : 'SystemAdministration/UserRole',
        redirectTo : 'Administration/UserRoles',
        pathMatch : 'full'
    },
    {
        path : 'SystemAdministration/Notification',
        redirectTo : 'Administration/Notifications',
        pathMatch : 'full'
    },
    {
        path : 'Site/Site/Details/:plantid',
        redirectTo : 'Operating/Plants/:plantid',
        pathMatch : 'full'
    },
    {
        path : 'Site/Site/Documentation/:plantid',
        redirectTo : 'Operating/Plants/:plantid/Files',
        pathMatch : 'full'
    },
    {
        path : 'Operating/Plants/:plantid/Documentation',
        redirectTo : 'Operating/Plants/:plantid/Files',
        pathMatch : 'full'
    },
    {
        path : 'Operating/Plants/:plantid/Documentation/Add',
        redirectTo : 'Operating/Plants/:plantid/Files/Add',
        pathMatch : 'full'
    },
    {
        path : 'Operating/Plants/:plantid/Documentation/:fileid/Details',
        redirectTo : 'Operating/Plants/:plantid/Files/:fileid',
        pathMatch : 'full'
    },
    {
        path : 'Site/Site/Alarms/:plantid',
        redirectTo : 'Operating/Plants/:plantid/Alarms',
        pathMatch : 'full'
    },
    {
        path : 'Site/Site/WebPicture/:plantid',
        redirectTo : 'Operating/Plants/:plantid/WebPicture',
        pathMatch : 'full'
    },
    {
        path : 'SystemAdministration/BillingProduct/Settings/:billingid',
        redirectTo : 'Administration/BillingProduct/:billingid/Settings',
        pathMatch : 'full'
    },
    {
        path : 'SystemAdministration/BillingProduct/Details/:billingid',
        redirectTo : 'Administration/BillingProduct/:billingid/Settings',
        pathMatch : 'full'
    },
    {
        path : 'SystemAdministration/BillingProduct',
        redirectTo : 'Administration/BillingProduct:_rest',
        pathMatch : 'full'
    },
    {
        path :  'SystemAdministration/BillingNotificationTemplate/Settings/:billingnotficationid',
        redirectTo : 'SystemAdministration/BillingNotificationTemplate/:billingnotficationid/Settings/',
        pathMatch : 'full'
    },
    {
        path :  'SystemAdministration/BillingNotificationTemplate/Details/:billingnotficationid',
        redirectTo : 'SystemAdministration/BillingNotificationTemplate/:billingnotficationid/Settings/',
        pathMatch : 'full'
    },
    {
        path : 'Site/Site/SiteFile/:plantid',
        redirectTo : '/Operating/Plants/:plantid/Documentation/Add',
        pathMatch : 'full'
    },
    {
        path : 'Site/Site/Tasks/:plantid',
        redirectTo : '/Operating/Plants/:plantid/Tasks',
        pathMatch : 'full'
    },
    {
        path : 'Home/Trend/:tileid/:dashboardid',
        redirectTo : '/Home/Dashboards/:dashboardid/Trend/:tileid',
        pathMatch : 'full'
    },
    {
        path : 'Site/SiteAdministration/List',
        redirectTo : '/Administration/Plants',
        pathMatch : 'full'
    },
    {
        path : 'Account/Manage',
        redirectTo : '/Account/Profile',
        pathMatch : 'full'
    },
    {
        path : 'Site/Site',
        redirectTo : '/Operating/Plants',
        pathMatch : 'full'
    },
    {
        path : 'HomePage/:dashboardid',
        redirectTo : '/Home/Dashboards/:dashboardid',
        pathMatch : 'full'
    },
    {
        path : 'HomePage',
        redirectTo : '/Home/HomePage',
        pathMatch : 'full'
    },
    {
        path : 'Site/ApplicationSet/List',
        redirectTo: '/ApplicationSet',
        pathMatch : 'full'
    }
];
